import { render, staticRenderFns } from "./PopulationStructure.vue?vue&type=template&id=05abb9f9"
import script from "./PopulationStructure.vue?vue&type=script&lang=js"
export * from "./PopulationStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports